var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1116(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 18.094,
    viewBox: "0 0 38 18.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116",
    transform: "translate(-311.94 -419.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M325.721,434.528c-.219,0-.3-.02-.261-.28a4.816,4.816,0,0,0-9.445-1.816,4.344,4.344,0,0,0-.091,1.865c.036.19-.016.234-.2.231-.678-.011-1.357.009-2.034-.01a1.78,1.78,0,0,1-1.735-1.741q-.025-2.769,0-5.538a1.785,1.785,0,0,1,1.8-1.758c1-.011,2.01-.012,3.014,0a.392.392,0,0,0,.435-.295c.529-1.312,1.071-2.618,1.611-3.925a2.715,2.715,0,0,1,2.712-1.817q6.838,0,13.676-.006a2.157,2.157,0,0,1,1.615.664c1.7,1.693,3.415,3.37,5.111,5.065a1.3,1.3,0,0,0,.744.378q3.2.559,6.407,1.13a.911.911,0,0,1,.861,1c0,1.394.014,2.788,0,4.182a2.718,2.718,0,0,1-2.49,2.655c-.2.014-.315.024-.274-.262a4.815,4.815,0,0,0-9.448-1.8,4.16,4.16,0,0,0-.091,1.791c.052.268-.052.278-.264.277m-1.494-9.049c1.218,0,2.436,0,3.655,0,.239,0,.452-.03.564-.279s-.02-.43-.19-.6q-1.552-1.512-3.1-3.025a1.094,1.094,0,0,0-.811-.327c-1.243.007-2.487,0-3.73,0a.919.919,0,0,0-1.012,1.034q0,1.074,0,2.147a.927.927,0,0,0,1.047,1.038C333.483,425.481,334.676,425.479,335.869,425.479Zm-9.259,0c.69,0,1.381,0,2.071,0a.929.929,0,0,0,1.053-1.031q.006-1.092,0-2.184a.914.914,0,0,0-1-1q-2.127-.006-4.255,0a.913.913,0,0,0-1,1.011q-.007,1.092,0,2.184a.921.921,0,0,0,1.022,1.024C325.2,425.482,325.907,425.479,326.61,425.479Z",
    transform: "translate(0 0)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M363.883,529.337a3.919,3.919,0,1,1,3.954-3.855A3.922,3.922,0,0,1,363.883,529.337Zm2.145-3.9a2.11,2.11,0,1,0-2.123,2.089A2.115,2.115,0,0,0,366.028,525.441Z",
    transform: "translate(-43.228 -91.801)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M579.9,529.338a3.919,3.919,0,1,1,3.942-3.867A3.922,3.922,0,0,1,579.9,529.338Zm2.132-3.9a2.11,2.11,0,1,0-2.124,2.088A2.115,2.115,0,0,0,582.028,525.443Z",
    transform: "translate(-237.521 -91.801)",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1116);
export default __webpack_public_path__ + "static/media/Group 1116.0940f7830c802be4945ea859b9dd609b.svg";
export { ForwardRef as ReactComponent };